import React from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;

const dateRange = {
  ['今天']: [moment().startOf('d'), moment().endOf('d')],
  ['昨天']: [
    moment()
      .subtract(1, 'd')
      .startOf('d'),
    moment()
      .subtract(1, 'd')
      .endOf('d')
  ],
  ['过去7天']: [
    moment()
      .subtract(7, 'd')
      .startOf('d'),
    moment()
      .subtract(1, 'd')
      .endOf('d')
  ],
  ['过去30天']: [
    moment()
      .subtract(30, 'd')
      .startOf('d'),
    moment()
      .subtract(1, 'd')
      .endOf('d')
  ]
};

const CustomerPicker = props => {
  const { onChange } = props;
  return (
    <RangePicker
      format="YYYY/MM/DD"
      allowClear={false}
      {...props}
      disabledDate={current => {
        if (current) {
          return (
            current > moment().endOf('d') ||
            current <
              moment()
                .subtract(3, 'months')
                .endOf('d')
          );
        }
        return false;
      }}
      onChange={val => {
        if (val && val.length > 0) {
          onChange(val);
        }
      }}
      ranges={dateRange}
      style={{ width: 260 }}
    />
  );
};

export default CustomerPicker;
